import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  Container,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Tooltip,
  useMediaQuery,
  Modal,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useUser } from "../context/UserContext";
import AddItem from "../components/AddItems";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTheme } from "@mui/material/styles";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { fetchItemsByOrgId, updateItem, deleteItem, validatePassword, getAllBillByOrgId } from "../services/api";
import { styled } from "@mui/styles";
import SpinnerLoading from "../utility/LoadingIndicator";

const ItemView = () => {
  const [items, setItems] = useState([]);
  const [bills, setBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [password, setPassword] = useState("");
  const [passwordDialogOpen, setPasswordDailogOpen] = useState(false);
  const [updatedData, setUpdatedData] = useState({
    itemName: "",
    item_quantity: "",
    item_stockQuantity: "",
    item_cost: "",

  });
  const { user } = useUser();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeDevice = useMediaQuery(theme.breakpoints.up("lg")); // For large devices
  const isExtraLargeDevice = useMediaQuery(theme.breakpoints.up("xl"));
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(true);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  let matchingBill;

  //fetch items by orgId
  const fetchItems = async () => {
    if (!user || !user.orgId) return;

    try {
      const response = await fetchItemsByOrgId(user.orgId);
      if (
        response &&
        response.status === 200 &&
        Array.isArray(response.data.data)
      ) {
        setItems(response.data.data);
        console.log(response.data.data);

      } else {
        setItems([]);
      }
    } catch (error) {
      console.error("Failed to fetch items:", error);
      setItems([]);
    }
    finally {
      setLoading(false);

    }
  };

  // get all bills by orgId
  const fetchBills = async (orgId) => {
    try {
      const response = await getAllBillByOrgId(orgId);
      if (response?.status === 200 && Array.isArray(response.data.data)) {

        setBills(response.data.data);
        console.log(response.data.data);
      } else {
        setBills([]);
      }
    } catch (error) {
      console.error("Failed to fetch bills:", error);
      setBills([]);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchItems();
    fetchBills(user.orgId);
  }, [user]);

  //Edit and update item method
  const handleEditClick = (item) => {
    setCurrentItem(item);
    setUpdatedData({
      itemName: item.itemName,
      item_quantity: item.item_quantity,
      item_stockQuantity: item.item_stockQuantity,
      item_cost: item.item_cost,
      item_sellingCost: item.item_sellingCost,
    });

    setOpenEdit(true);
  };
  // delete item method
  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setPasswordDailogOpen(true);
  };
  const handleFocus = () => {
    setUpdatedData((prevData) => ({
      ...prevData,
      item_stockQuantity: "",
    }));
  };
  // Confirm to delete item method
  const confirmDelete = async () => {
    if (itemToDelete) {
      try {
        const response = await deleteItem(
          itemToDelete.itemName,
          itemToDelete.billId,
          user.orgId,
        );
        if (
          response.status === 200 ||
          response.message === "Item deleted successfully."
        ) {
          toast.success("Item successfully removed!");
          setItems(
            items.filter((item) => item.itemName !== itemToDelete.itemName)
          );
          fetchItems();
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("Error deleting item:", error);
      }
    }
    setOpenDeleteDialog(false);
  };
  const handleOpenAddDialog = () => setOpenAdd(true);
  const handleCloseAddDialog = () => {
    setOpenAdd(false);
    fetchItems();
  };
  const handleCloseEditDialog = () => setOpenEdit(false);

  const handleChange = (e) => {
    setUpdatedData({
      ...updatedData,
      [e.target.name]: e.target.value,
    });
  };
  //item updated method
  const handleUpdateSubmit = async () => {
    console.log(currentItem);
    console.log(updatedData)
    if (currentItem) {
      try {
        const response = await updateItem(
          currentItem.itemName,
          currentItem.billId,
          user.orgId,
          updatedData
        );
        if (response.status === 200) {
          toast.success("Items Successfully Updated..!");
          fetchItems();
          setOpenEdit(false);
        }
        if (
          response.message ===
          "Please change at least one value to update the item."
        ) {
          toast.warn("Please change at least one value to update the item.");
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const errorMessage = error.response.data.message;
          toast.error(errorMessage);
        } else {

          toast.error("An error occurred while updating the item.");
        }
      }
    }
  };

  const filteredItems = Array.isArray(items)
  ? items.filter((item) =>
      item.itemName?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];


  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handlePasswordVerify = async () => {
    try {
      console.log(user.userId);
      const response = await validatePassword(user.userId, password);
      if (response.status === 200) {

        setPasswordDailogOpen(false);
        setOpenDeleteDialog(true);
        setPassword("");
      } else {
        toast.error("Password not verified. Please check password and try again.!");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message;

      if (errorMessage === "Invalid credentials.") {
        toast.error("Password not verified. Please check password and try again.");
      } else {
        toast.error(errorMessage || "User ID not found. Please enter correct UserID.");
      }
    }
  };


  return (

    <>
    <style>
        {`
          @media (min-width: 1200px) {
            .css-1gjhc30-MuiContainer-root {
              max-width: 100vw !important;
            }
          }
        `}
      </style>

      <Container sx={{ maxWidth: '1400px' }}>
        <ToastContainer />
        <Box sx={{ pt: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexDirection={isMobile ? "column" : "row"}
            gap={2}
            marginBottom="10px"
          >
            <Typography
              sx={{ color: "#024CAA" }}
              variant={isMobile ? "h6" : "h5"}
              gutterBottom
            >
              Beverage Items
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search by item name"
              sx={{
                input: { color: "#071952", padding: "8px" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#071952" },
                  "&:hover fieldset": { borderColor: "#071952" },
                  "&.Mui-focused fieldset": { borderColor: "#3572EF" },
                },
                width: isMobile ? "100%" : "32%",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon style={{ color: "#071952" }} />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenAddDialog}
              fullWidth={isMobile}
              sx={{
                marginLeft: { xs: "auto", sm: "0px" },
                marginRight: { xs: "auto", sm: "0px" },
                marginTop: isMobile ? 1 : 0,
                width: { xs: "80%", sm: "auto" },
                textTransform: "none"
              }}
            >
              Add Stock
            </Button>
          </Box>

          <TableContainer
            component={Paper}
            sx={{
              maxHeight: isExtraLargeDevice
                ? 520 // Height for extra-large devices
                : isLargeDevice
                  ? 420 // Height for large devices
                  : 370, // Default height for other devices
              maxWidth: isExtraLargeDevice ? "100vw" : "none", // Max-width cap for XL
              margin: isExtraLargeDevice ? "0 auto" : "inherit", // Center for XL
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              "&::-webkit-scrollbar": {
                width: "6px",
                height: "6px",
              },
              "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "6px",
              },
              "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
            }}
          >
            <Table stickyHeader size={isMobile ? "small" : "medium"}>
              <TableHead sx={{ color: "#071952" }}>
                <TableRow>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "550",
                      maxWidth: "250px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Item Code
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "550",
                      maxWidth: "250px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Bill Date
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "550",
                      maxWidth: "250px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Item Name
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "550",
                      maxWidth: "300px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Quantity (ml)
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "550",
                      maxWidth: "300px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Stock Quantity
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "550",
                      maxWidth: "300px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    MRP
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "550",
                      minWidth: "130px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {
                  filteredItems.length > 0 ? (
                    filteredItems.slice().reverse().map((item, index) => (
                      // Find the bill object that matches the item's billId
                      matchingBill = bills.find(bill => bill._id === item.billId),
                      <TableRow key={index}>
                        <TableCell align="center">{item.itemId}</TableCell>
                        <TableCell align="center">{matchingBill ? matchingBill.billName :
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="100%" // Spinner height inside table
                          >
                            <SpinnerLoading color="primary" />
                          </Box>
                        }</TableCell>
                        <TableCell align="center">{item.itemName}</TableCell>
                        <TableCell align="center">{item.item_quantity}</TableCell>
                        <TableCell align="center">{item.item_stockQuantity}</TableCell>
                        <TableCell align="center">₹ {item.item_sellingCost}</TableCell>
                        <TableCell align="center">
                          <Tooltip title="Edit">
                            <IconButton onClick={() => handleEditClick(item)}>
                              <EditIcon color="primary" />
                            </IconButton>
                          </Tooltip>
                          {user.role === "owner" && <Tooltip title="Delete">
                            <IconButton onClick={() => handleDeleteClick(item)}>
                              <DeleteIcon color="error" />
                            </IconButton>
                          </Tooltip>}

                        </TableCell>
                      </TableRow>
                    ))
                  ) : loading ? (<TableRow>
                    <TableCell colSpan={7} align="center" sx={{ padding: 0, height: "60px" }}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100%" // Spinner height inside table
                      >
                        <SpinnerLoading color="primary" />
                      </Box>
                    </TableCell>
                  </TableRow>) : (
                    <TableRow>
                      <TableCell colSpan={7} align="center" sx={{ color: "#133E87", padding: 0, height: "50px" }}>
                        No items found
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {openAdd && (
          <Modal open={openAdd} onClose={handleCloseAddDialog}>

            <AddItem handleCloseAddDialog={handleCloseAddDialog} />

          </Modal>
        )}

        <Dialog
          open={openEdit}
          onClose={handleCloseEditDialog}
          item={items}
          PaperProps={{
            sx: {
              position: "absolute", // Position the modal
              top: "50%", // Center vertically
              left: "50%", // Center horizontally
              transform: "translate(-50%, -50%)", // Translate to center
              width: "400px", // Set the desired width
              maxHeight: "none", // Remove content height limit
              overflow: "visible", // Prevent scrollbars
            },
          }}
        >
          <DialogTitle sx={{ color: "#0079FF" }}>Edit Item</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              label="Item Name"
              name="itemName"
              fullWidth
              value={updatedData.itemName}
              onChange={handleChange}
              size="small"
              maxWidth="400"
            />
            <TextField
              margin="dense"
              label="Quantity (ml)"
              name="item_quantity"
              type="number"
              fullWidth
              value={updatedData.item_quantity}
              onChange={handleChange}
              disabled
              size="small"
            />
            <TextField
              margin="dense"
              label={`Current Stock Quantity`}
              name="item_stockQuantity"
              type="number"
              fullWidth
              value={updatedData.item_stockQuantity}
              onChange={handleChange}
              onFocus={handleFocus}
              InputProps={{ inputProps: { min: 0 } }}
              size="small"
            />
            <TextField
              margin="dense"
              label="Cost"
              name="item_cost"
              type="number"
              fullWidth
              value={updatedData.item_cost}
              onChange={handleChange}
              size="small"
            />
            <TextField
              margin="dense"
              label="Selling Cost"
              name="item_sellingCost"
              type="number"
              fullWidth
              value={updatedData.item_sellingCost}
              onChange={handleChange}
              size="small"
            />
          </DialogContent>
          <DialogActions sx={{ paddingBottom: "20px" }}>
            <Button
              variant="outlined"
              onClick={handleCloseEditDialog}
              sx={{ textTransform: "none" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleUpdateSubmit}
              color="primary"
              variant="contained"
              sx={{ textTransform: "none", marginRight: "18px", textTransform: 'nonw' }}

            >
              Update
            </Button>
          </DialogActions>
        </Dialog>



        {/* Verify Password Modal */}
        <Dialog
          open={passwordDialogOpen}
          onClose={() => setPasswordDailogOpen(false)}
          sx={{ borderRadius: "10px" }}
        >
          <DialogTitle style={{ color: "#006BFF" }}>Verify Password</DialogTitle>
          <DialogContent>
            <TextField
              sx={{ marginTop: "5px" }}
              label="Password"
              fullWidth
              size="small"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </DialogContent>
          <DialogActions sx={{ margin: "10px 14px 10px 0px " }}>
            <Button variant="outlined" onClick={() => setPasswordDailogOpen(false)} sx={{ textTransform: "none" }}>Cancel</Button>
            <Button variant="contained" onClick={handlePasswordVerify} color="primary" sx={{ textTransform: "none" }}>
              Verify
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete confirmation dialog  */}
        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
          sx={{
            '& .MuiDialog-paper': {
              width: '400px', // Set the desired width
              maxWidth: '90%', // Adjust for responsiveness
              paddingBottom: '20px',
              paddingRight: "20px", borderRadius: "8px"
            },
          }}
        >
          <DialogTitle sx={{ color: "#EB8317" }}>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this item?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)} variant="outlined">
              Cancel
            </Button>
            <Button onClick={confirmDelete} color="primary" variant="contained">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>


  );
};

export default ItemView;